import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "./ProjectEntity";
import { ProjectTemplateVersionEntity } from "./ProjectTemplateVersionEntity";
import { PhaseEntity } from "./PhaseEntity";
import { BugWorkflowEntity } from "./BugWorkflowEntity";
import { BugGroupEntity } from "./BugGroupEntity";
import { BugStateEntity } from "./BugStateEntity";
import { BugTransitionEntity } from "./BugTransitionEntity";
import { RegionTypeEntity } from "./RegionTypeEntity";
import { RegionEntity } from "./RegionEntity";
import { MapEntity } from "./MapEntity";
import { MapVersionEntity } from "./MapVersionEntity";
import { MapLocationEntity } from "./MapLocationEntity";
import { MapSceneEntity } from "./MapSceneEntity";
import { PersonEntity } from "./PersonEntity";
import { RegionMemberEntity } from "./RegionMemberEntity";
import { ProjectMemberEntity } from "./ProjectMemberEntity";
import { WorkPackageEntity } from "./WorkPackageEntity";
import { WorkPackageDescriptionEntity } from "./WorkPackageDescriptionEntity";
import { VisitTypeEntity } from "./VisitTypeEntity";
import { ProjectUserRoleEntity } from "./ProjectUserRoleEntity";
import { ProjectUserRole_TransitionsEntity } from "./ProjectUserRole_TransitionsEntity";
import { ProjectUserRole_BugGroupsEntity } from "./ProjectUserRole_BugGroupsEntity";
import { Phase_BugGroupsEntity } from "./Phase_BugGroupsEntity";
import { ProjectUserRightEntity } from "./ProjectUserRightEntity";
import { ProjectUserEntity } from "./ProjectUserEntity";
import { VisitEntity } from "./VisitEntity";
import { DeliveryVisitEntity } from "./DeliveryVisitEntity";
import { VisitMemberEntity } from "./VisitMemberEntity";
import { PlanningEventCategoryEntity } from "./PlanningEventCategoryEntity";
import { PlanningEventEntity } from "./PlanningEventEntity";
import { PlanningEventLogEntity } from "./PlanningEventLogEntity";
import { FormTypeEntity } from "./FormTypeEntity";
import { FormTypeVersionEntity } from "./FormTypeVersionEntity";
import { FormTypeViewEntity } from "./FormTypeViewEntity";
import { FormEntity } from "./FormEntity";
import { BugEntity } from "./BugEntity";
import { BugNoteEntity } from "./BugNoteEntity";
import { RemarkStyleEntity } from "./RemarkStyleEntity";
import { RemarkCategoryEntity } from "./RemarkCategoryEntity";
import { RemarkCategoryHierarchyEntity } from "./RemarkCategoryHierarchyEntity";
import { RemarkEntity } from "./RemarkEntity";
import { DocumentEntity } from "./DocumentEntity";
import { DocumentVersionEntity } from "./DocumentVersionEntity";
import { BugAnnotationEntity } from "./BugAnnotationEntity";
import { BugNoteAnnotationEntity } from "./BugNoteAnnotationEntity";
import { RemarkAnnotationEntity } from "./RemarkAnnotationEntity";
import { SignatureEntity } from "./SignatureEntity";
import { SignOffEntity } from "./SignOffEntity";
import { ReportGroupEntity } from "./ReportGroupEntity";
import { ReportEntity } from "./ReportEntity";
import { promoimmoEntity } from "./promoimmoEntity";
export { ProjectEntity } from "./ProjectEntity";
export { ProjectTemplateVersionEntity } from "./ProjectTemplateVersionEntity";
export { PhaseEntity } from "./PhaseEntity";
export { BugWorkflowEntity } from "./BugWorkflowEntity";
export { BugGroupEntity } from "./BugGroupEntity";
export { BugStateEntity } from "./BugStateEntity";
export { BugTransitionEntity } from "./BugTransitionEntity";
export { RegionTypeEntity } from "./RegionTypeEntity";
export { RegionEntity } from "./RegionEntity";
export { MapEntity } from "./MapEntity";
export { MapVersionEntity } from "./MapVersionEntity";
export { MapLocationEntity } from "./MapLocationEntity";
export { MapSceneEntity } from "./MapSceneEntity";
export { PersonEntity } from "./PersonEntity";
export { RegionMemberEntity } from "./RegionMemberEntity";
export { ProjectMemberEntity } from "./ProjectMemberEntity";
export { WorkPackageEntity } from "./WorkPackageEntity";
export { WorkPackageDescriptionEntity } from "./WorkPackageDescriptionEntity";
export { VisitTypeEntity } from "./VisitTypeEntity";
export { ProjectUserRoleEntity } from "./ProjectUserRoleEntity";
export { ProjectUserRole_TransitionsEntity } from "./ProjectUserRole_TransitionsEntity";
export { ProjectUserRole_BugGroupsEntity } from "./ProjectUserRole_BugGroupsEntity";
export { Phase_BugGroupsEntity } from "./Phase_BugGroupsEntity";
export { ProjectUserRightEntity } from "./ProjectUserRightEntity";
export { ProjectUserEntity } from "./ProjectUserEntity";
export { VisitEntity } from "./VisitEntity";
export { DeliveryVisitEntity } from "./DeliveryVisitEntity";
export { VisitMemberEntity } from "./VisitMemberEntity";
export { PlanningEventCategoryEntity } from "./PlanningEventCategoryEntity";
export { PlanningEventEntity } from "./PlanningEventEntity";
export { PlanningEventLogEntity } from "./PlanningEventLogEntity";
export { FormTypeEntity } from "./FormTypeEntity";
export { FormTypeVersionEntity } from "./FormTypeVersionEntity";
export { FormTypeViewEntity } from "./FormTypeViewEntity";
export { FormEntity } from "./FormEntity";
export { BugEntity } from "./BugEntity";
export { BugNoteEntity } from "./BugNoteEntity";
export { RemarkStyleEntity } from "./RemarkStyleEntity";
export { RemarkCategoryEntity } from "./RemarkCategoryEntity";
export { RemarkCategoryHierarchyEntity } from "./RemarkCategoryHierarchyEntity";
export { RemarkEntity } from "./RemarkEntity";
export { DocumentEntity } from "./DocumentEntity";
export { DocumentVersionEntity } from "./DocumentVersionEntity";
export { BugAnnotationEntity } from "./BugAnnotationEntity";
export { BugNoteAnnotationEntity } from "./BugNoteAnnotationEntity";
export { RemarkAnnotationEntity } from "./RemarkAnnotationEntity";
export { SignatureEntity } from "./SignatureEntity";
export { SignOffEntity } from "./SignOffEntity";
export { ReportGroupEntity } from "./ReportGroupEntity";
export { ReportEntity } from "./ReportEntity";
export { promoimmoEntity } from "./promoimmoEntity";
export const entityClasses = {
    Project: ProjectEntity,
    ProjectTemplateVersion: ProjectTemplateVersionEntity,
    Phase: PhaseEntity,
    BugWorkflow: BugWorkflowEntity,
    BugGroup: BugGroupEntity,
    BugState: BugStateEntity,
    BugTransition: BugTransitionEntity,
    RegionType: RegionTypeEntity,
    Region: RegionEntity,
    Map: MapEntity,
    MapVersion: MapVersionEntity,
    MapLocation: MapLocationEntity,
    MapScene: MapSceneEntity,
    Person: PersonEntity,
    RegionMember: RegionMemberEntity,
    ProjectMember: ProjectMemberEntity,
    WorkPackage: WorkPackageEntity,
    WorkPackageDescription: WorkPackageDescriptionEntity,
    VisitType: VisitTypeEntity,
    ProjectUserRole: ProjectUserRoleEntity,
    ProjectUserRole_Transitions: ProjectUserRole_TransitionsEntity,
    ProjectUserRole_BugGroups: ProjectUserRole_BugGroupsEntity,
    Phase_BugGroups: Phase_BugGroupsEntity,
    ProjectUserRight: ProjectUserRightEntity,
    ProjectUser: ProjectUserEntity,
    Visit: VisitEntity,
    DeliveryVisit: DeliveryVisitEntity,
    VisitMember: VisitMemberEntity,
    PlanningEventCategory: PlanningEventCategoryEntity,
    PlanningEvent: PlanningEventEntity,
    PlanningEventLog: PlanningEventLogEntity,
    FormType: FormTypeEntity,
    FormTypeVersion: FormTypeVersionEntity,
    FormTypeView: FormTypeViewEntity,
    Form: FormEntity,
    Bug: BugEntity,
    BugNote: BugNoteEntity,
    RemarkStyle: RemarkStyleEntity,
    RemarkCategory: RemarkCategoryEntity,
    RemarkCategoryHierarchy: RemarkCategoryHierarchyEntity,
    Remark: RemarkEntity,
    Document: DocumentEntity,
    DocumentVersion: DocumentVersionEntity,
    BugAnnotation: BugAnnotationEntity,
    BugNoteAnnotation: BugNoteAnnotationEntity,
    RemarkAnnotation: RemarkAnnotationEntity,
    Signature: SignatureEntity,
    SignOff: SignOffEntity,
    ReportGroup: ReportGroupEntity,
    Report: ReportEntity,
    promoimmo: promoimmoEntity,
} as const satisfies Record<string, typeof BaseEntity>;
